/**
 * Shared block styles for in-page notice bars.
 *
 * Azure is the product accent, not a badge the AI wears, so the question for a
 * notice bar is not "did AI make this?" — it's "does this need the user to do
 * something?". That is what the accent marks: act here, you are here, this is
 * live.
 *
 * The fill is a separate problem. `--ai-accent-soft` is 85% saturation in a
 * system that runs at 9%: as a chip it reads as a marker, stretched across a
 * bar it reads as a highlighter — and it says the same thing whether the bar
 * wants attention or is only reporting. The accent belongs on an edge, a chip,
 * an icon or a word, never on a surface.
 *
 * - `NOTICE_ACT`   — a decision is waiting on the user. 2px accent left edge.
 * - `NOTICE_QUIET` — nothing to act on: work in progress, or plain information.
 *   Loading states take this one and put the accent on the spinner instead, so
 *   they don't compete with the actionable bar they turn into moments later.
 *
 * Both are block styles only. Call sites add their own layout (`flex`, `gap`).
 */
export const NOTICE_ACT =
  'rounded-lg border border-border border-l-2 border-l-[hsl(var(--brand))] bg-muted px-3.5 py-2.5'

export const NOTICE_QUIET = 'rounded-lg border border-border bg-muted px-3.5 py-2.5'
